var map = {
	"./adult/nn/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 768,
	"./adult/no/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 769,
	"./child/de/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 770,
	"./youth/de/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 771,
	"./youth/nn/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 772,
	"./youth/no/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 773,
	"./youth/se/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 767;